module.exports = __webpack_public_path__ + "img/40.2b8929bd.gif";